/**
 * Кинематографичный «заход в ресторан» (Veo) — единый клип для секции
 * HeroLaunch (hero + «Запуск за 1 день» слиты в ОДНУ закреплённую секцию
 * с ОДНИМ видео, 2026-06-20). Десктоп скрабит currentTime непрерывно
 * 0→duration за всю дорожку, поэтому шва между блоками нет вообще:
 *   · Фаза A (hero, 0..HERO_CLIP_SPLIT): улица → дверь → зал.
 *   · Фаза B (launch, HERO_CLIP_SPLIT..1): проход вглубь к открытой кухне.
 * На мобильном (scroll-scrub дёргается) клип делится по HERO_CLIP_SPLIT на
 * два блока в потоке: hero автоплеем 1-й половины, «Запуск» — 2-й.
 */
// all-intra (каждый кадр — ключевой) → чёткий и плавный scroll-scrub:
// браузер при перемотке снапится к ключевым кадрам, а их теперь 360, не ~10.
// Новое имя = заодно cache-bust. Разрешение 720p (исходник Veo) — не поднять.
export const ENTRANCE_VIDEO = `${import.meta.env.BASE_URL}hero-entrance-hq.mp4`;
// Постер = 0-й кадр клипа (улица/подход ко входу). Раньше hero-entrance.jpg
// был кадром из середины (~2-3с, у двери) → при первом заходе мелькал не тот
// кадр перед стартом. Новое имя — заодно cache-bust.
export const ENTRANCE_POSTER = `${import.meta.env.BASE_URL}hero-entrance-start.jpg`;

/** Доля клипа, проигрываемая в hero; остаток продолжается в следующем блоке. */
export const HERO_CLIP_SPLIT = 0.5;
